import React from 'react';
import TransactionModule from './transaction.module';
import ProductCmms from 'enums/products-cmms';

const TransactionSAModule = () => {
  return (
    <div>
      <TransactionModule product={ProductCmms.Savings} />
    </div>
  );
};

export default TransactionSAModule;
